import { formatDateOnlyToDDMMYYYY } from '../../../shared/lib/date/date-utils';
import { getCategoryIcon } from '../config/category-icons';

const TRANSACTION_COLORS = { Income: '#4DB8A8', Expense: '#b75252' };

const findCategory = (categories, categoryId) =>
	categoryId
		? (categories.find(
				category => category.id === categoryId || category._id === categoryId,
			) ?? null)
		: null;

const toTransaction = (record, index, categories, type) => {
	const category = findCategory(categories, record.category_id);
	const categoryName = category?.name || record.category || 'Other';

	return {
		id: `${type}-${record.id ?? index}`,
		type,
		category: categoryName,
		icon: getCategoryIcon(category?.original_name || categoryName),
		currency: record.currency,
		amount: Number(record.amount) || 0,
		rawDate: record.date,
		date: formatDateOnlyToDDMMYYYY(record.date),
		color: TRANSACTION_COLORS[type],
	};
};

export const toTransactions = ({
	incomes,
	expenses,
	incomeCategories,
	expenseCategories,
}) =>
	[
		...incomes.map((income, index) =>
			toTransaction(income, index, incomeCategories, 'Income'),
		),
		...expenses.map((expense, index) =>
			toTransaction(expense, index, expenseCategories, 'Expense'),
		),
	].sort((a, b) => new Date(b.rawDate) - new Date(a.rawDate));
